import { useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Container
} from '@mui/material';

import {createApiCall} from "../api/api-service"
const BrandFormTable = () => {
  const [formData, setFormData] = useState({
    brand_name: '',
    brand_offical_url: '',
    brand_image: ''
  });

  const [brands, setBrands] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddBrand =  async () => {
    if (formData.brand_name && formData.brand_offical_url && formData.brand_image) {
      setBrands((prev) => [...prev, formData]);
      setFormData({
        brand_name: '',
        brand_offical_url: '',
        brand_image: ''
      });
     await createApiCall("POST","/inventory/add_brand",{"brand_name":formData.brand_name,'offical_url':formData.brand_offical_url,'brand_image':formData.brand_image})
    }
  };

  return (
    <>
      {/* Form Section */}
      <Container sx={{marginTop:'10px'}}>

      
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Brand Name"
            name="brand_name"
            value={formData.brand_name}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Official URL"
            name="brand_offical_url"
            value={formData.brand_offical_url}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Image URL"
            name="brand_image"
            value={formData.brand_image}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" onClick={handleAddBrand}>
            Add Brand
          </Button>
        </Grid>
      </Grid>

      {/* Table Section */}
      <Typography variant="h6" gutterBottom>
        Added Brands
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Brand Name</TableCell>
              <TableCell>Official URL</TableCell>
              <TableCell>Image</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {brands.map((brand, index) => (
              <TableRow key={index}>
                <TableCell>{brand.brand_name}</TableCell>
                <TableCell>
                  <a href={brand.brand_offical_url} target="_blank" rel="noopener noreferrer">
                    {brand.brand_offical_url}
                  </a>
                </TableCell>
                <TableCell>
                  <img src={brand.brand_image} alt={brand.brand_image} width="50" height="50" style={{ borderRadius: '6px' }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </Container>
    </>
  );
};

export default BrandFormTable;
